var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 312.376,
    height: 180,
    viewBox: "0 0 312.376 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70939",
    "data-name": "Rectangle 70939",
    width: 312.376,
    height: 180,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497426",
    "data-name": "Path 497426",
    d: "M301.158,200.129l4.056,0v-1.484l-4.059-4.052Z",
    transform: "translate(-301.154 -194.59)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497427",
    "data-name": "Path 497427",
    d: "M301.154,194.586l4.059,4.052H306.7l0-4.056Z",
    transform: "translate(-301.154 -194.582)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497428",
    "data-name": "Path 497428",
    d: "M408.7,194.514l0,4.056h1.484l4.053-4.058Z",
    transform: "translate(-408.703 -194.51)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497429",
    "data-name": "Path 497429",
    d: "M411.49,198.568v1.484l4.056,0,0-5.539Z",
    transform: "translate(-411.49 -194.51)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497430",
    "data-name": "Path 497430",
    d: "M411.557,302.061v1.484l4.059,4.053,0-5.539Z",
    transform: "translate(-411.557 -302.059)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497431",
    "data-name": "Path 497431",
    d: "M408.777,304.846l0,4.056,5.539,0-4.059-4.053Z",
    transform: "translate(-408.777 -304.845)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497432",
    "data-name": "Path 497432",
    d: "M305.287,304.914l-4.053,4.059,5.54,0,0-4.056Z",
    transform: "translate(-301.234 -304.913)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497433",
    "data-name": "Path 497433",
    d: "M301.227,302.135l0,5.539,4.053-4.059v-1.484Z",
    transform: "translate(-301.227 -302.132)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497434",
    "data-name": "Path 497434",
    d: "M164.412,200.129l4.056,0v-1.484l-4.058-4.052Z",
    transform: "translate(-164.408 -194.59)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497435",
    "data-name": "Path 497435",
    d: "M164.408,194.586l4.058,4.052h1.484l0-4.056Z",
    transform: "translate(-164.408 -194.582)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497436",
    "data-name": "Path 497436",
    d: "M271.956,194.514l0,4.056h1.484l4.053-4.058Z",
    transform: "translate(-271.956 -194.51)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497437",
    "data-name": "Path 497437",
    d: "M274.743,198.568v1.484l4.056,0,0-5.539Z",
    transform: "translate(-274.743 -194.51)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497438",
    "data-name": "Path 497438",
    d: "M274.811,302.061v1.484l4.058,4.053,0-5.539Z",
    transform: "translate(-274.811 -302.059)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497439",
    "data-name": "Path 497439",
    d: "M272.03,304.846l0,4.056,5.539,0-4.058-4.053Z",
    transform: "translate(-272.03 -304.845)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497440",
    "data-name": "Path 497440",
    d: "M168.54,304.914l-4.052,4.059,5.539,0,0-4.056Z",
    transform: "translate(-164.488 -304.913)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497441",
    "data-name": "Path 497441",
    d: "M164.48,302.135l0,5.539,4.052-4.059v-1.484Z",
    transform: "translate(-164.48 -302.132)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_269821",
    "data-name": "Group 269821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269820",
    "data-name": "Group 269820",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497417",
    "data-name": "Path 497417",
    d: "M277.169,151.346c-1.269.706-2.627,1.38-4.057,2.039a137.242,137.242,0,0,1-24.864,8.186c-.6.146-1.205.291-1.817.433l-.153.036c-1.147.271-2.316.534-3.495.789-10.637,2.322-22.534,4.224-35.146,5.741l-.715.085c-.058.008-.112.012-.171.02-16.835,1.995-34.917,3.31-52.931,4q-4.25.164-8.487.279c-.477.012-.954.028-1.43.036-.418.012-.832.024-1.25.032q-2.719.067-5.424.113c-.679.016-1.358.024-2.038.036-.513.008-1.026.016-1.543.02-4.439.061-8.847.081-13.2.069-37.233-.117-70.517-2.861-87.258-7.575-48.379-13.62-37.714-47.161-7.107-53.975S14.357,65.282,63.161,39.153c29.646-15.872,60.7,18.651,86.385-8.955,38.322-41.187,72.215-34.457,93.574-13.189,24.071,23.966,4.759,53.189,30.536,51.7,38.626-2.232,61.684,50.253,3.513,82.637",
    transform: "translate(0 -0.066)",
    fill: "#ebeeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497418",
    "data-name": "Path 497418",
    d: "M314.674,375.934c0,3.887-59.26,7.038-132.361,7.038s-132.361-3.151-132.361-7.038,59.26-7.038,132.361-7.038,132.361,3.151,132.361,7.038",
    transform: "translate(-27.484 -202.972)",
    fill: "#d1d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497419",
    "data-name": "Path 497419",
    d: "M118.934,266.688l-9.942,6.9c-19.743,1.855-33.374-4.973-42.1-12.329l3.844-8.537-8.4,4.23a48.5,48.5,0,0,1-8.123-11.207c36.348-19.062,63.778,21,64.725,20.947",
    transform: "translate(-29.827 -132.38)",
    fill: "#469e9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497420",
    "data-name": "Path 497420",
    d: "M72.5,257.276c.546-.167,16.133,2.2,36.27,15.89",
    transform: "translate(-39.892 -141.553)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497421",
    "data-name": "Path 497421",
    d: "M121.56,204.187l-13.377,1.594c-41.122-17.1-39.354-55.963-39.354-55.963a50.076,50.076,0,0,1,14.227,2.027c-1.864,5.321.975,7.533,3.638,7.533,2.406,0,3.629-2.012,2.79-5.051,27.023,12.981,31.286,49.492,32.076,49.86",
    transform: "translate(-37.864 -82.432)",
    fill: "#55c0bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497422",
    "data-name": "Path 497422",
    d: "M96.508,184.9s5.115,10.808,22.245,25.068",
    transform: "translate(-53.1 -101.738)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16748",
    "data-name": "Ellipse 16748",
    cx: 3.539,
    cy: 3.539,
    r: 3.539,
    transform: "translate(20.028 149.729)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16749",
    "data-name": "Ellipse 16749",
    cx: 3.539,
    cy: 3.539,
    r: 3.539,
    transform: "translate(282.668 92.191)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    y2: 5.135,
    transform: "translate(272.843 84.28)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x1: 5.135,
    transform: "translate(270.275 86.848)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    y2: 5.51,
    transform: "translate(39.961 142.096)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x1: 5.511,
    transform: "translate(37.205 144.852)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497423",
    "data-name": "Path 497423",
    d: "M283.433,374.653H244.455a2,2,0,0,1,0-4.009h38.977a2,2,0,1,1,0,4.009",
    transform: "translate(-133.4 -203.934)",
    fill: "#494f70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70910",
    "data-name": "Rectangle 70910",
    width: 28.161,
    height: 16.875,
    transform: "translate(116.463 152.496)",
    fill: "#373b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497424",
    "data-name": "Path 497424",
    d: "M272.2,235.051H144.464a4.229,4.229,0,0,1-4.228-4.229V139.208a4.229,4.229,0,0,1,4.228-4.229H272.2a4.229,4.229,0,0,1,4.229,4.229v91.614a4.229,4.229,0,0,1-4.229,4.229",
    transform: "translate(-77.16 -74.268)",
    fill: "#373b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497425",
    "data-name": "Path 497425",
    d: "M275.835,226.68H152.481a1.586,1.586,0,0,1-1.585-1.585V146.805a1.586,1.586,0,0,1,1.585-1.585H275.835a1.585,1.585,0,0,1,1.585,1.585v78.289a1.585,1.585,0,0,1-1.585,1.585",
    transform: "translate(-83.025 -79.902)",
    fill: "#494f70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70911",
    "data-name": "Rectangle 70911",
    width: 0.896,
    height: 2.834,
    transform: "translate(136.698 131.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70912",
    "data-name": "Rectangle 70912",
    width: 0.896,
    height: 2.834,
    transform: "translate(136.694 125.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70913",
    "data-name": "Rectangle 70913",
    width: 0.896,
    height: 2.834,
    transform: "translate(136.689 118.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70914",
    "data-name": "Rectangle 70914",
    width: 0.896,
    height: 2.834,
    transform: "translate(136.685 112.663)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70915",
    "data-name": "Rectangle 70915",
    width: 0.896,
    height: 2.834,
    transform: "translate(136.681 106.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70916",
    "data-name": "Rectangle 70916",
    width: 0.896,
    height: 2.834,
    transform: "translate(136.677 100.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70917",
    "data-name": "Rectangle 70917",
    width: 0.896,
    height: 2.834,
    transform: "translate(136.673 93.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70918",
    "data-name": "Rectangle 70918",
    width: 2.834,
    height: 0.896,
    transform: "translate(141.797 88.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70919",
    "data-name": "Rectangle 70919",
    width: 2.834,
    height: 0.896,
    transform: "translate(148.04 88.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70920",
    "data-name": "Rectangle 70920",
    width: 2.834,
    height: 0.896,
    transform: "translate(154.283 88.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70921",
    "data-name": "Rectangle 70921",
    width: 2.834,
    height: 0.896,
    transform: "translate(160.526 88.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70922",
    "data-name": "Rectangle 70922",
    width: 2.834,
    height: 0.896,
    transform: "translate(166.769 88.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70923",
    "data-name": "Rectangle 70923",
    width: 2.834,
    height: 0.896,
    transform: "translate(173.012 88.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70924",
    "data-name": "Rectangle 70924",
    width: 2.834,
    height: 0.896,
    transform: "translate(179.255 88.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70925",
    "data-name": "Rectangle 70925",
    width: 0.896,
    height: 2.834,
    transform: "translate(186.396 93.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70926",
    "data-name": "Rectangle 70926",
    width: 0.896,
    height: 2.834,
    transform: "translate(186.4 100.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70927",
    "data-name": "Rectangle 70927",
    width: 0.896,
    height: 2.834,
    transform: "translate(186.404 106.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70928",
    "data-name": "Rectangle 70928",
    width: 0.896,
    height: 2.834,
    transform: "translate(186.409 112.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70929",
    "data-name": "Rectangle 70929",
    width: 0.896,
    height: 2.834,
    transform: "translate(186.413 118.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70930",
    "data-name": "Rectangle 70930",
    width: 0.896,
    height: 2.834,
    transform: "translate(186.417 125.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70931",
    "data-name": "Rectangle 70931",
    width: 0.896,
    height: 2.834,
    transform: "translate(186.421 131.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70932",
    "data-name": "Rectangle 70932",
    width: 2.834,
    height: 0.896,
    transform: "translate(179.359 138.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70933",
    "data-name": "Rectangle 70933",
    width: 2.834,
    height: 0.896,
    transform: "translate(173.116 138.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70934",
    "data-name": "Rectangle 70934",
    width: 2.834,
    height: 0.896,
    transform: "translate(166.873 138.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70935",
    "data-name": "Rectangle 70935",
    width: 2.834,
    height: 0.896,
    transform: "translate(160.63 138.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70936",
    "data-name": "Rectangle 70936",
    width: 2.834,
    height: 0.896,
    transform: "translate(154.387 138.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70937",
    "data-name": "Rectangle 70937",
    width: 2.834,
    height: 0.896,
    transform: "translate(148.144 138.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70938",
    "data-name": "Rectangle 70938",
    width: 2.834,
    height: 0.896,
    transform: "translate(141.9 138.454)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269823",
    "data-name": "Group 269823",
    transform: "translate(135.175 87.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269822",
    "data-name": "Group 269822",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70940",
    "data-name": "Rectangle 70940",
    width: 1.062,
    height: 3.188,
    transform: "translate(1.44 0.472)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269825",
    "data-name": "Group 269825",
    transform: "translate(135.072 87.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269824",
    "data-name": "Group 269824",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70941",
    "data-name": "Rectangle 70941",
    width: 3.188,
    height: 1.062,
    transform: "translate(0.396 1.441)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269827",
    "data-name": "Group 269827",
    transform: "translate(183.31 87.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269826",
    "data-name": "Group 269826",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70942",
    "data-name": "Rectangle 70942",
    width: 3.188,
    height: 1.062,
    transform: "translate(1.879 1.44)",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269829",
    "data-name": "Group 269829",
    transform: "translate(184.701 87.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269828",
    "data-name": "Group 269828",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70943",
    "data-name": "Rectangle 70943",
    width: 1.062,
    height: 3.188,
    transform: "translate(1.553 0.395)",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269831",
    "data-name": "Group 269831",
    transform: "translate(184.731 135.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269830",
    "data-name": "Group 269830",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70944",
    "data-name": "Rectangle 70944",
    width: 1.063,
    height: 3.188,
    transform: "translate(1.557 1.879)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269833",
    "data-name": "Group 269833",
    transform: "translate(183.342 136.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269832",
    "data-name": "Group 269832",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70945",
    "data-name": "Rectangle 70945",
    width: 3.188,
    height: 1.063,
    transform: "translate(1.959 1.554)",
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269835",
    "data-name": "Group 269835",
    transform: "translate(135.108 136.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269834",
    "data-name": "Group 269834",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70946",
    "data-name": "Rectangle 70946",
    width: 3.188,
    height: 1.063,
    transform: "translate(0.472 1.557)",
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269837",
    "data-name": "Group 269837",
    transform: "translate(135.208 135.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269836",
    "data-name": "Group 269836",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70947",
    "data-name": "Rectangle 70947",
    width: 1.063,
    height: 3.188,
    transform: "translate(1.44 1.959)",
    fill: "#fff"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269839",
    "data-name": "Group 269839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269838",
    "data-name": "Group 269838",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70948",
    "data-name": "Rectangle 70948",
    width: 0.896,
    height: 2.834,
    transform: "translate(75.191 131.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70949",
    "data-name": "Rectangle 70949",
    width: 0.896,
    height: 2.834,
    transform: "translate(75.187 125.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70950",
    "data-name": "Rectangle 70950",
    width: 0.896,
    height: 2.834,
    transform: "translate(75.183 118.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70951",
    "data-name": "Rectangle 70951",
    width: 0.896,
    height: 2.834,
    transform: "translate(75.178 112.663)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70952",
    "data-name": "Rectangle 70952",
    width: 0.896,
    height: 2.834,
    transform: "translate(75.174 106.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70953",
    "data-name": "Rectangle 70953",
    width: 0.896,
    height: 2.834,
    transform: "translate(75.17 100.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70954",
    "data-name": "Rectangle 70954",
    width: 0.896,
    height: 2.834,
    transform: "translate(75.166 93.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70955",
    "data-name": "Rectangle 70955",
    width: 2.834,
    height: 0.896,
    transform: "translate(80.29 88.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70956",
    "data-name": "Rectangle 70956",
    width: 2.834,
    height: 0.896,
    transform: "translate(86.533 88.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70957",
    "data-name": "Rectangle 70957",
    width: 2.834,
    height: 0.896,
    transform: "translate(92.776 88.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70958",
    "data-name": "Rectangle 70958",
    width: 2.834,
    height: 0.896,
    transform: "translate(99.019 88.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70959",
    "data-name": "Rectangle 70959",
    width: 2.834,
    height: 0.896,
    transform: "translate(105.262 88.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70960",
    "data-name": "Rectangle 70960",
    width: 2.834,
    height: 0.896,
    transform: "translate(111.506 88.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70961",
    "data-name": "Rectangle 70961",
    width: 2.834,
    height: 0.896,
    transform: "translate(117.749 88.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70962",
    "data-name": "Rectangle 70962",
    width: 0.896,
    height: 2.834,
    transform: "translate(124.889 93.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70963",
    "data-name": "Rectangle 70963",
    width: 0.896,
    height: 2.834,
    transform: "translate(124.893 100.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70964",
    "data-name": "Rectangle 70964",
    width: 0.896,
    height: 2.834,
    transform: "translate(124.898 106.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70965",
    "data-name": "Rectangle 70965",
    width: 0.896,
    height: 2.834,
    transform: "translate(124.902 112.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70966",
    "data-name": "Rectangle 70966",
    width: 0.896,
    height: 2.834,
    transform: "translate(124.906 118.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70967",
    "data-name": "Rectangle 70967",
    width: 0.896,
    height: 2.834,
    transform: "translate(124.91 125.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70968",
    "data-name": "Rectangle 70968",
    width: 0.896,
    height: 2.834,
    transform: "translate(124.914 131.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70969",
    "data-name": "Rectangle 70969",
    width: 2.834,
    height: 0.896,
    transform: "translate(117.853 138.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70970",
    "data-name": "Rectangle 70970",
    width: 2.834,
    height: 0.896,
    transform: "translate(111.609 138.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70971",
    "data-name": "Rectangle 70971",
    width: 2.834,
    height: 0.896,
    transform: "translate(105.366 138.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70972",
    "data-name": "Rectangle 70972",
    width: 2.834,
    height: 0.896,
    transform: "translate(99.123 138.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70973",
    "data-name": "Rectangle 70973",
    width: 2.834,
    height: 0.896,
    transform: "translate(92.88 138.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70974",
    "data-name": "Rectangle 70974",
    width: 2.834,
    height: 0.896,
    transform: "translate(86.637 138.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70975",
    "data-name": "Rectangle 70975",
    width: 2.834,
    height: 0.896,
    transform: "translate(80.394 138.454)",
    fill: "#fff"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269841",
    "data-name": "Group 269841",
    transform: "translate(73.796 87.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269840",
    "data-name": "Group 269840",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70977",
    "data-name": "Rectangle 70977",
    width: 1.062,
    height: 3.188,
    transform: "translate(1.439 0.472)",
    fill: "#fff"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269843",
    "data-name": "Group 269843",
    transform: "translate(73.739 87.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269842",
    "data-name": "Group 269842",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70978",
    "data-name": "Rectangle 70978",
    width: 3.188,
    height: 1.062,
    transform: "translate(0.395 1.441)",
    fill: "#fff"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269845",
    "data-name": "Group 269845",
    transform: "translate(121.976 87.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269844",
    "data-name": "Group 269844",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70979",
    "data-name": "Rectangle 70979",
    width: 3.188,
    height: 1.062,
    transform: "translate(1.879 1.44)",
    fill: "#fff"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269847",
    "data-name": "Group 269847",
    transform: "translate(123.321 87.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269846",
    "data-name": "Group 269846",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70980",
    "data-name": "Rectangle 70980",
    width: 1.062,
    height: 3.188,
    transform: "translate(1.553 0.395)",
    fill: "#fff"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269849",
    "data-name": "Group 269849",
    transform: "translate(123.351 135.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269848",
    "data-name": "Group 269848",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70981",
    "data-name": "Rectangle 70981",
    width: 1.063,
    height: 3.188,
    transform: "translate(1.557 1.879)",
    fill: "#fff"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269851",
    "data-name": "Group 269851",
    transform: "translate(122.009 136.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269850",
    "data-name": "Group 269850",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70982",
    "data-name": "Rectangle 70982",
    width: 3.188,
    height: 1.063,
    transform: "translate(1.959 1.554)",
    fill: "#fff"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269853",
    "data-name": "Group 269853",
    transform: "translate(73.775 136.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269852",
    "data-name": "Group 269852",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70983",
    "data-name": "Rectangle 70983",
    width: 3.188,
    height: 1.063,
    transform: "translate(0.472 1.557)",
    fill: "#fff"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269855",
    "data-name": "Group 269855",
    transform: "translate(73.828 135.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269854",
    "data-name": "Group 269854",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70984",
    "data-name": "Rectangle 70984",
    width: 1.063,
    height: 3.188,
    transform: "translate(1.44 1.959)",
    fill: "#fff"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269857",
    "data-name": "Group 269857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269856",
    "data-name": "Group 269856",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497442",
    "data-name": "Path 497442",
    d: "M321.54,272.871V258.6s4.3-5.141,13.938,1.619,14.5,1.853,19.8,0l1.381-.563.228,13.3Z",
    transform: "translate(-176.916 -141.258)",
    fill: "#373b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497443",
    "data-name": "Path 497443",
    d: "M363.264,231.941a5.58,5.58,0,1,0,5.58-5.58,5.58,5.58,0,0,0-5.58,5.58",
    transform: "translate(-199.874 -124.547)",
    fill: "#373b54"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70985",
    "data-name": "Rectangle 70985",
    width: 56.239,
    height: 56.239,
    transform: "matrix(0.723, -0.691, 0.691, 0.723, 70.595, 87.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70986",
    "data-name": "Rectangle 70986",
    width: 40.612,
    height: 40.612,
    transform: "translate(81.643 88.047) rotate(-43.701)",
    fill: "#f3c700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497444",
    "data-name": "Path 497444",
    d: "M218.8,202.516l-9.224,8.815-28.058-29.36L193.308,170.7c3.348.732,6.6,2.37,8.171,5.758,3.9,8.417-3.309,15.936,5.364,17.9,5.7,1.286,10.023,4.653,11.957,8.16",
    transform: "translate(-99.874 -93.924)",
    fill: "#d64d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497445",
    "data-name": "Path 497445",
    d: "M259.584,192.055a6.056,6.056,0,1,0,6.192-5.917,6.056,6.056,0,0,0-6.192,5.917",
    transform: "translate(-142.826 -102.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497446",
    "data-name": "Path 497446",
    d: "M533.222,151.573s-3.031.945-5.373-3.6c-2.923-5.675-15.789,8.56-3.7,9.208,5.163.277,11.6,4.384,11.6,4.384s6.62-5.207,3.422-9.045c-1.408-1.69-3.75-.535-3.75-.535s2.91-2.369,1.788-2.961-2.967,2.742-2.967,2.742-.861-3.372-1.879-2.318c-.833.863.86,2.127.86,2.127",
    transform: "translate(-285.595 -80.682)",
    fill: "#373b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497447",
    "data-name": "Path 497447",
    d: "M499.42,181.789A23.173,23.173,0,0,1,476.337,166a2.984,2.984,0,0,0-2.389-1.918c-2.745-.387-3.839,1.829-8.711,3.121-3.841,1.019,1.236,6.692,2.742,8.765,10.054,13.834,13.39,12.393,29.672,13.284Z",
    transform: "translate(-255.207 -90.254)",
    fill: "#d64d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497448",
    "data-name": "Path 497448",
    d: "M518.657,263.013l-13.26,48.7s8.2,1.447,23.144,1.205l-.964-30.858Z",
    transform: "translate(-278.077 -144.714)",
    fill: "#494f70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497449",
    "data-name": "Path 497449",
    d: "M542.618,261.685l-1.094,48.059s7.909,7.237,22.052,2.4l-6.6-35.091Z",
    transform: "translate(-297.955 -143.983)",
    fill: "#494f70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497450",
    "data-name": "Path 497450",
    d: "M522.524,374.068H492.848c.19-1.226.579-3.709,1.4-4.758,2.581-3.291,5.115-2.436,5.115-2.436l22.272,3.134s.946,3.995.888,4.06",
    transform: "translate(-271.173 -201.805)",
    fill: "#373b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497451",
    "data-name": "Path 497451",
    d: "M555.866,373.949H527.044a.357.357,0,0,1-.351-.434,12.079,12.079,0,0,1,1.82-4.117,8.256,8.256,0,0,1,2.11-1.828,6.677,6.677,0,0,1,4.5-.857l20.036,3.139a.357.357,0,0,1,.293.271c.156.66.6,2.548.767,3.4a.357.357,0,0,1-.352.426",
    transform: "translate(-289.79 -201.725)",
    fill: "#373b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497452",
    "data-name": "Path 497452",
    d: "M540.824,322.745c-.439.293,1.316,23.994,1.316,23.994",
    transform: "translate(-297.531 -177.579)",
    fill: "#373b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497453",
    "data-name": "Path 497453",
    d: "M540.824,322.745c-.439.293,1.316,23.994,1.316,23.994",
    transform: "translate(-297.531 -177.579)",
    fill: "none",
    stroke: "#373b54",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70987",
    "data-name": "Rectangle 70987",
    width: 6.004,
    height: 11.934,
    transform: "translate(240.545 83.474) rotate(-10.62)",
    fill: "#fbaf7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497454",
    "data-name": "Path 497454",
    d: "M540.819,183.126l.784,4.183a18.4,18.4,0,0,1-5.246,4.6l-1.345-7.174c.109-.2.22-.395.342-.586Z",
    transform: "translate(-294.372 -100.759)",
    fill: "#fb8862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497455",
    "data-name": "Path 497455",
    d: "M527.623,159.712s-5.386,7.654-2.589,15.39a1.613,1.613,0,0,0,1.186,1.033c1.98.413,6.835,1.145,8.264-1.229,1.81-3.005,5.069-10.507,2.358-12.756s-9.218-2.438-9.218-2.438",
    transform: "translate(-288.439 -87.876)",
    fill: "#fbaf7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497456",
    "data-name": "Path 497456",
    d: "M546.975,180.142s4.049-1.9,5.592.658-4.478,5.123-5.284,2.649-.308-3.307-.308-3.307",
    transform: "translate(-300.871 -98.743)",
    fill: "#fbaf7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497457",
    "data-name": "Path 497457",
    d: "M526.377,163.508s.734-2.408,1.887-1.354,1.854,1.3,6.015.532c4.781-.887,2.628,6.138,2.628,6.138s1.54-1.735,2.867-1.222c0,0,1.064-7.663-1.8-8.714s-9.6-1.986-10.457-.514-1.144,5.134-1.144,5.134",
    transform: "translate(-289.621 -86.721)",
    fill: "#373b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497458",
    "data-name": "Path 497458",
    d: "M528.5,175.208c-.139.433-.418.73-.623.664s-.257-.47-.117-.9.418-.73.622-.664.257.47.118.9",
    transform: "translate(-290.34 -95.901)",
    fill: "#373b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497459",
    "data-name": "Path 497459",
    d: "M540.16,177.3c-.14.433-.418.73-.623.664s-.257-.47-.117-.9.418-.73.622-.664.257.47.118.9",
    transform: "translate(-296.754 -97.052)",
    fill: "#373b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497460",
    "data-name": "Path 497460",
    d: "M530.11,185.45c.123.008,4.169.432,4.169.432s-2.752,5.025-4.045-.424",
    transform: "translate(-291.675 -102.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497461",
    "data-name": "Path 497461",
    d: "M532.039,204.8s.9,3.277,5.884-.953l3.711.843a4.38,4.38,0,0,1,2.548,1.665c3.834,5.177,17.131,24.121,9.717,28.414-8.609,4.984-27.339-6.042-27.339-6.042l2.6-19.566a5.532,5.532,0,0,1,1.8-3.4Z",
    transform: "translate(-289.721 -112.162)",
    fill: "#d64d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497462",
    "data-name": "Path 497462",
    d: "M549.953,184.77s1.3.282,1.451-.6a.636.636,0,0,0-.565-.838s2.193-1.307,2.435,0-2.29,2.419-3.322,1.435",
    transform: "translate(-302.593 -100.554)",
    fill: "#fb8862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497463",
    "data-name": "Path 497463",
    d: "M571.732,398.325v0c-.009,0-.014,0-.014-.013s.014,0,.014.009",
    transform: "translate(-314.568 -219.16)",
    fill: "#373b54"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70988",
    "data-name": "Rectangle 70988",
    width: 57.968,
    height: 57.968,
    transform: "matrix(0.256, -0.967, 0.967, 0.256, 216.501, 149.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70989",
    "data-name": "Rectangle 70989",
    width: 41.86,
    height: 41.86,
    transform: "matrix(0.256, -0.967, 0.967, 0.256, 226.351, 143.829)",
    fill: "#ebeeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497464",
    "data-name": "Path 497464",
    d: "M547.077,296.813,543.7,309.524l-40.461-10.733,4.31-16.249c3.338-1.156,7.081-1.466,10.281.67,7.952,5.307,5.659,15.793,14.34,12.854,5.705-1.935,11.316-1.3,14.9.746",
    transform: "translate(-276.893 -154.962)",
    fill: "#55c0bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497465",
    "data-name": "Path 497465",
    d: "M578.491,268.093a2.907,2.907,0,1,0,3.556-2.065,2.908,2.908,0,0,0-3.556,2.065",
    transform: "translate(-318.241 -146.319)",
    fill: "#f3c700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497466",
    "data-name": "Path 497466",
    d: "M567.313,264.457s-3.863,8.645-2.918,10.01,3-1.468,3-1.468.01-3.713-1.613.915c-1,2.858,5.528,9.543,8.881,3.638,3.044-5.361,2.2-8.058,2.2-8.058Z",
    transform: "translate(-310.457 -145.508)",
    fill: "#fbaf7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497467",
    "data-name": "Path 497467",
    d: "M551.828,211.961s9.436,7.161,6.166,22.617a3.574,3.574,0,0,0,.374,3.041,46.129,46.129,0,0,1,10.625,4.769c1.231.838,2.2-.068,2.231-1.434.185-7.11-2.571-26.137-14.214-33.807Z",
    transform: "translate(-303.625 -113.976)",
    fill: "#d64d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497468",
    "data-name": "Path 497468",
    d: "M533.448,255.691a3.647,3.647,0,1,0,3.647-3.648,3.648,3.648,0,0,0-3.647,3.648",
    transform: "translate(-293.512 -138.678)",
    fill: "#f3c700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497469",
    "data-name": "Path 497469",
    d: "M525.94,172.305a2.773,2.773,0,1,1-2.773-2.772A2.773,2.773,0,0,1,525.94,172.305Z",
    transform: "translate(-286.33 -93.28)",
    fill: "none",
    stroke: "#373b54",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497470",
    "data-name": "Path 497470",
    d: "M541.707,174.686a2.832,2.832,0,1,1-2.832-2.832A2.832,2.832,0,0,1,541.707,174.686Z",
    transform: "translate(-294.939 -94.557)",
    fill: "none",
    stroke: "#373b54",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497471",
    "data-name": "Path 497471",
    d: "M473.8,149.849l.529-6.875-1.866-3.924a1.394,1.394,0,0,0-2.295-.335,3.987,3.987,0,0,0-1.285,3.331c.534,2.351,1.467,5.532,1.467,5.532l-4.7,5.438a14.62,14.62,0,0,0,8.149-3.166",
    transform: "translate(-256.206 -76.069)",
    fill: "#fbaf7b"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 1.595,
    y2: 0.35,
    transform: "translate(239.611 79.026)",
    fill: "none",
    stroke: "#373b54",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70990",
    "data-name": "Rectangle 70990",
    width: 46.132,
    height: 46.131,
    transform: "translate(80.143 55.166) rotate(-43.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70991",
    "data-name": "Rectangle 70991",
    width: 33.313,
    height: 33.313,
    transform: "translate(89.205 55.371) rotate(-43.701)",
    fill: "#469e9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497472",
    "data-name": "Path 497472",
    d: "M228.911,128.653l-7.566,7.231L198.329,111.8,208,102.557c2.746.6,5.416,1.944,6.7,4.723,3.2,6.9-2.714,13.072,4.4,14.68,4.676,1.055,8.222,3.817,9.808,6.693",
    transform: "translate(-109.124 -56.429)",
    fill: "#55c0bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497473",
    "data-name": "Path 497473",
    d: "M273.553,118.764a3.087,3.087,0,1,0,4.364.1,3.087,3.087,0,0,0-4.364-.1",
    transform: "translate(-149.988 -64.875)",
    fill: "#f3c700"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70992",
    "data-name": "Rectangle 70992",
    width: 57.968,
    height: 57.968,
    transform: "matrix(0.654, -0.757, 0.757, 0.654, 156.624, 49.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70993",
    "data-name": "Rectangle 70993",
    width: 41.86,
    height: 41.86,
    transform: "translate(167.985 48.578) rotate(-49.163)",
    fill: "#469e9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497474",
    "data-name": "Path 497474",
    d: "M413.75,109.868l-8.6,9.95L373.48,92.446l10.993-12.719c3.507.423,7.007,1.784,8.949,5.106,4.824,8.254,7.383,8.884,16.474,10.044,5.976.761,7.18,8.167,3.854,14.992",
    transform: "translate(-205.495 -43.867)",
    fill: "#55c0bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497475",
    "data-name": "Path 497475",
    d: "M436.251,79.794a2.907,2.907,0,1,0,2.688-3.111,2.907,2.907,0,0,0-2.688,3.111",
    transform: "translate(-240.028 -42.188)",
    fill: "#f3c700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497476",
    "data-name": "Path 497476",
    d: "M242.648,11.418a10.2,10.2,0,0,0-2.7.363,15.908,15.908,0,0,0-31.241,3.14,8.544,8.544,0,1,0-1.8,16.9h35.421v-.008c.1,0,.208.008.313.008a10.2,10.2,0,1,0,0-20.4",
    transform: "translate(-109.146)",
    fill: "#ebeeff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70994",
    "data-name": "Rectangle 70994",
    width: 8.768,
    height: 11.275,
    transform: "translate(121.181 13.973)",
    fill: "#d64d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497477",
    "data-name": "Path 497477",
    d: "M269.973,60.779l3.758-3.255,3.758-3.255H262.456l3.758,3.255Z",
    transform: "translate(-144.407 -29.86)",
    fill: "#d64d8b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.3705f0bda459fcdc65717ef3576de589.svg";
export { ForwardRef as ReactComponent };